import { render, staticRenderFns } from "./PermisosGrupo.vue?vue&type=template&id=52958dc5&"
import script from "./PermisosGrupo.vue?vue&type=script&lang=js&"
export * from "./PermisosGrupo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports